import { clsx } from "clsx";
import { HTMLAttributes, ReactNode } from "react";

export interface TableHeaderProps extends HTMLAttributes<HTMLTableSectionElement> {
  /**
   * Preferencialmente Table.Column.
   * ReactNode é aceito para permitir map(), fragments e renderização condicional.
   */
  children: ReactNode;
}

export const TableHeader = ({ children, className, ...props }: TableHeaderProps) => (
  <thead className={clsx("bg-background-secondary", className)} {...props}>
    <tr className="border border-background-secondary">{children}</tr>
  </thead>
);
